import { render } from "./TableCategory.vue?vue&type=template&id=737294b4&scoped=true"
import script from "./TableCategory.vue?vue&type=script&lang=js"
export * from "./TableCategory.vue?vue&type=script&lang=js"

import "./TableCategory.vue?vue&type=style&index=0&id=737294b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737294b4"]])

export default __exports__